import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";

import Layout from "../components/Layout";
import DataList from "../components/DataList";

import usePageMetadata from "../hooks/usePageMetadata";
import useAuthorizedPages from "../hooks/useAuthorizedPages";

const ListScreen = () => {
  const navigate = useNavigate();
  const { localDB, store, list_columns, pageId, title, primary_key } =
    usePageMetadata();
  const { authorizedPages, isCurrentPageAuthorized } = useAuthorizedPages();

  useEffect(() => {
    if (!authorizedPages || authorizedPages.length === 0) return;
    if (isCurrentPageAuthorized) return;

    // Redirect to the first authorized page's list view (data grid)
    const fallbackPage = authorizedPages[0];
    const destination = `/${fallbackPage}`;
    navigate(destination, { replace: true });
  }, [
    authorizedPages,
    isCurrentPageAuthorized,
    navigate,
  ]);

  if (
    authorizedPages.length > 0 &&
    !isCurrentPageAuthorized
  ) {
    return null;
  }

  return (
    <Layout showMenu>
      <Container
        component="main"
        sx={{
          maxWidth: { xs: "sm", md: "md", lg: "lg", xl: "xl" },
        }}
      >
        <DataList
          localDB={localDB}
          store={store}
          fields={list_columns}
          pageId={pageId}
          title={title}
          primaryKey={primary_key}
        />
      </Container>
    </Layout>
  );
};

export default ListScreen;
